export const GET_TENANTS_START = 'GET_TENANTS_START';
export const GET_TENANTS_SUCCESS = 'GET_TENANTS_SUCCESS';
export const GET_TENANTS_FAIL = 'GET_TENANTS_FAIL';
export const GET_TENANT_ID_START = 'GET_TENANT_ID_START';
export const GET_TENANT_ID_SUCCESS = 'GET_TENANT_ID_SUCCESS';
export const GET_TENANT_ID_FAIL = 'GET_TENANT_ID_FAIL';
export const EDIT_TENANT_START = 'EDIT_TENANT_START';
export const EDIT_TENANT_SUCCESS = 'EDIT_TENANT_SUCCESS';
export const EDIT_TENANT_FAIL = 'EDIT_TENANT_FAIL';
export const ADD_TENANT_START = 'ADD_TENANT_START';
export const ADD_TENANT_SUCCESS = 'ADD_TENANT_SUCCESS';
export const ADD_TENANT_FAIL = 'ADD_TENANT_FAIL';
export const GET_TENANTS_RESIDENCE_START = 'GET_TENANTS_RESIDENCE_START';
export const GET_TENANTS_RESIDENCE_SUCCESS = 'GET_TENANTS_RESIDENCE_SUCCESS';
export const GET_TENANTS_RESIDENCE_FAIL = 'GET_TENANTS_RESIDENCE_FAIL';
